import { render } from "./KoursesRemoveFromMembership.vue?vue&type=template&id=32e04a48"
import script from "./KoursesRemoveFromMembership.vue?vue&type=script&lang=js"
export * from "./KoursesRemoveFromMembership.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__